"use client";

import { Table, TableBody, TableHead, TablePagination } from "@mui/material";
import React from "react";

import {
  HeaderTableCell,
  TableContainer,
  TableHeaderRow,
} from "@/components/molecules/Table/styled";
import { DEFAULT_ROWS_PER_PAGE_OPTIONS } from "@/constants/pagination";
import INotification from "@/interfaces/notification.interface";
import { NotificationsMessages } from "@/messages/notifications/notifications.messages";
import { Pagination } from "@/types/page.types";
import { PaginatedResponse } from "@/types/requests.types";

import { NotificationTableRow } from "./row";
import { NOTIFICATIONS_TABLE_COLUMNS } from "../../constants";

interface NotificationTableProps {
  data: PaginatedResponse<INotification>;
  pagination: Pagination;
  messages: NotificationsMessages;
}

export function NotificationTable({ data, pagination, messages }: NotificationTableProps) {
  return (
    <>
      <TableContainer>
        <Table stickyHeader aria-label="sticky table">
          <TableHead>
            <TableHeaderRow>
              {NOTIFICATIONS_TABLE_COLUMNS(messages).map((label, index) => (
                <HeaderTableCell key={`${index} - ${label}`}>{label}</HeaderTableCell>
              ))}
            </TableHeaderRow>
          </TableHead>
          <TableBody>
            {data.items &&
              data.items.map((notification, index) => (
                <NotificationTableRow
                  key={`${index} - ${notification.id}`}
                  notification={notification}
                  index={index}
                  messages={messages}
                />
              ))}
          </TableBody>
        </Table>
      </TableContainer>

      <TablePagination
        labelRowsPerPage={messages.rowsPerPage}
        rowsPerPageOptions={DEFAULT_ROWS_PER_PAGE_OPTIONS}
        component="div"
        count={data.totalCount}
        onRowsPerPageChange={(e) => pagination.extend(Number(e.target.value))}
        rowsPerPage={pagination.pageSize}
        page={pagination.pageNumber - 1}
        onPageChange={(_, pageNumber) => pagination.changePage(pageNumber)}
      />
    </>
  );
}
